import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.17 15.44a1.6 1.6 0 0 1 .12-.15.9997.9997 0 0 1 1.42 0A1 1 0 0 1 13 16a1 1 0 0 1-.06.38.9.9 0 0 1-.54.54.94.94 0 0 1-.76 0 .9.9 0 0 1-.54-.54.84.84 0 0 1-.08-.38 1.4 1.4 0 0 1 0-.2.64.64 0 0 1 .06-.18.76.76 0 0 1 .09-.18M6.4443 3.6853a10 10 0 1 1 11.1114 16.6295A10 10 0 0 1 6.4443 3.6853m1.1111 14.9665a8.0005 8.0005 0 0 0 10.1015-.995 8.0001 8.0001 0 1 0-10.1015.995",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M12 7a3 3 0 0 0-2.6 1.5 1 1 0 1 0 1.73 1A1 1 0 0 1 12 9a1 1 0 1 1 0 2 1 1 0 0 0-1 1v1a1.0001 1.0001 0 0 0 2 0v-.18a3 3 0 0 0 1.9334-3.3281A3 3 0 0 0 12 7"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M12 20c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8m0 2c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10",
        clipRule: "evenodd"
    }, "2")
], "ChannelUnknown", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
